import axios from "axios";

const baseURL = "https://crabby-moccasins-jay.cyclic.app/api/"

const axiosInstance = axios.create({
  baseURL,
});

export default axiosInstance;
